<script>
import { ResetAttributesService } from "@/common/resetPlanProvisionAttributes.service";

export default {
  methods: {
    resetAttributes(design, attribute) {
      const attributes = ResetAttributesService.attributesToReset(
        attribute,
        design.$model[attribute]
      );
      attributes.forEach(
        attrToReset =>
          (design.$model[attrToReset] = attrToReset === "tiers" ? [] : null)
      );
      design.$reset();
    }
  }
};
</script>
